export const organisationExcelHeaders = [
  { label: 'Prov.Reg.Id', key: 'provisinal_registration_id' },
  { label: 'Registration Number', key: 'registration_number' },
  { label: 'Category', key: 'user_category_type.category_name' },
  { label: 'Sub Category', key: 'user_category_sub_type.sub_category_name' },
  { label: 'Name of Institution', key: 'name_of_organization' },
  { label: 'Address (Full Postal Address)', key: 'address' },
  { label: 'Institution Email', key: 'email' },
  { label: 'Contact Person Name', key: 'contact_person_name' },
  { label: 'Contact Person Designation', key: 'contact_person_designation' },
  { label: 'Contact Person Contact Number', key: 'contact_person_contact' },
   { label: 'Affiliated Sports Body', key: 'affiliated_sport_body' },
  
];